<template>
  <div>
    <div class="domainCon" :class="theme==0?'dark':'white'">
      <div class="title">
        <!-- 什么是MNS -->
        {{$t('myCenter.whatMns')}}
        <div class="line"></div>
      </div>

      <div class="des1">
        {{$t('myCenter.mnsDes1')}}
        <!-- MNS是Mints Name Service缩写，它是一个基于树图区块链的可扩展和开放式化的命名系统，主要服务于用户可读区块链地址映射名称，旨在为用户提供简短易读的名称，可通过购买获得。 -->
      </div>
      <div class="des1">
        {{$t('myCenter.mnsDes2')}}
        <!-- MNS是你的“元宇宙”起点，是属于每个人的数字身份名片，它会连接你在数字世界中的成就、贡献、兴趣和活动，一旦拥有它，它就会和你的区块链地址绑定，成为你数字资产的一部分。 -->
      </div>
      <div class="des2">
        <!-- 1、获得MNS之后可以绑定自己的区块链地址。 -->
        {{$t('myCenter.mnsDes3')}}
        <br>
        <!-- 2、用户需先完成实名认证，再进行购买。每个用户都可以通过搜索栏检索寻找想要购买的MNS，如此前未有人注册过，您即可发起购买，支付完成后进入审核阶段。 -->
        {{$t('myCenter.mnsDes4')}}
        <br>
        <!-- 3、MNS可以是26个英文字母及10个阿拉伯数字任意顺序组成，现阶段可购买至少要用7个字符组成，并会自动在组合文字后面添加“.mints”的后缀，如“ab12.mints”。 -->
        {{$t('myCenter.mnsDes5')}}
        <br>
        <!-- 4、所有MNS购买前都需要完成审核，您设置的名称不得侵犯或涉嫌侵犯他人的合法权益。设置名称时遵守以下规定： -->
        {{$t('myCenter.mnsDes6')}}
        <br>
        <!-- （1）名称及其读音、音译、翻译不得与党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名相同； -->
        {{$t('myCenter.mnsDes7')}}
        <br>
        <!-- （2）名称及其读音、音译、翻译不得与国家机构或其他机构的名称相同； -->
        {{$t('myCenter.mnsDes8')}}
        <br>
        <!-- （3）名称及其读音、音译、翻译不得包含歧视、侮辱、猥亵类词语；  -->
        {{$t('myCenter.mnsDes9')}}
        <br>
        <!-- （4）名称及其读音、音译、翻译不得侵害有关驰名商标的权利； -->
        {{$t('myCenter.mnsDes10')}}
        <br>
        <!-- （5）不设置易产生歧义、引起他人误解的账号的名称； -->
        {{$t('myCenter.mnsDes11')}}
        <br>
        <!-- （6）不得危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一； -->
        {{$t('myCenter.mnsDes12')}}
        <br>
        <!-- （7）不得损害国家荣誉和利益的，损害公共利益； -->
        {{$t('myCenter.mnsDes13')}}
        <br>
        <!-- （8）不得煽动民族仇恨、民族歧视，破坏民族团结； -->
        {{$t('myCenter.mnsDes14')}}

        <br>
        <!-- （9）不得破坏国家宗教政策，宣扬邪教和封建迷信； -->
        {{$t('myCenter.mnsDes15')}}
        <br>（
        <!-- 10）不得散布谣言，扰乱社会秩序，破坏社会稳定； -->
        {{$t('myCenter.mnsDes16')}}
        <br>
        <!-- （11）不得散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪； -->
        {{$t('myCenter.mnsDes17')}}
        <br>
        <!-- （12）不得侮辱或者诽谤他人，侵害他人合法权益； -->
        {{$t('myCenter.mnsDes18')}}
        <br>
        <!-- （13）不得违反宪法或法律法规规定； -->
        {{$t('myCenter.mnsDes19')}}
        <br>
        <!-- （14）不得含有法律、行政法规禁止的其他内容。 -->
        {{$t('myCenter.mnsDes20')}}
        <br>
        {{$t('myCenter.mnsDes21')}}
        <!-- 如您设置的名称涉嫌侵犯他人合法权益或者含有法律、行政法规等规范性文件、监管政策等禁止的内容，我们有权拒绝通过。 -->
        <br>
        {{$t('myCenter.mnsDes22')}}
        <!-- 5、名称通过审核后，用户即可拥有此MNS的使用权。 -->

        <br>
        {{$t('myCenter.mnsDes23')}}
        <!-- 6、你的好友可以通过名称搜索关注你以及访问你的空间。 -->
        <br>
        <!-- 7、
        若您已购买的MNS中包含涉嫌侵犯他人合法权益或者含有法律、行政法规等规范性文件、监管政策等禁止的词汇或者该等词汇的读音、音译、翻译的，薄盒有权收回您已购买的MNS，在收回后您无权使用该MNS。我们对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。 -->
        {{$t('myCenter.mnsDes24')}}
        <br>
        {{$t('myCenter.mnsDes25')}}
        <!-- 8、您理解并确认，因MNS不能篡改的特殊性，MNS一旦售出，不支持退换。 -->
        <br>
        {{$t('myCenter.mnsDes26')}}
        <!-- 您理解并确认，薄盒有权根据国家法律法规、监管政策的变化或风险防范的需要对MNS的相关服务作出调整或更新，我们会以公告等通知方式就与MNS相关服务的更新向您进行提示。除通知中另有说明外，更新的内容将于更新公告公布的生效之日起生效。若您不接受变更后的服务内容或功能，或不同意更新后的相关协议内容，您需立即停止使用相关服务。若您继续使用薄盒提供的相关MNS服务的，即视为您已同意我们作出的变更，并自愿接受变更后的协议内容约束。 -->
      </div>
      <!-- <div class="bottomBtn">敬请期待</div> -->
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }

  }

</script>
<style scoped lang="less">
  .domainCon {
    padding: 42px 15px 25px;

    .title {
      font-size: 25px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #FFFFFF;
      margin-bottom: 34px;
    }



    .des1 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #BDBDBD;
    }

    .des2 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #83878B;
      margin-top: 25px;
    }

    .bottomBtn {
      width: 100%;
      height: 45px;
      background: url(/static/img/myCenter/gradientBg.png) no-repeat;
      background-size: 100% 100%;
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 45px;
      color: #000000;
      text-align: center;
      margin-top: 30px;
    }
  }

  .dark {
    background: #000000 !important;

    .title {
      color: #FFFFFF !important;
    }

    .des1 {
      color: #BDBDBD !important;
    }

    .des2 {
      color: #83878B !important;
    }
  }

  .white {
    background: #ffffff !important;

    .title {
      color: #333333 !important;
    }

    .des1 {
      color: #444444 !important;
    }

    .des2 {
      color: #555555 !important
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/myCenter/myDomainName.vue